import React from 'react'
import Admin from "../../Admin/Admin"

const Admindiv = () => {
  return (
    <div>
      <Admin/>
    </div>
  )
}

export default Admindiv
